import { render } from "./types.md?vue&type=template&id=09f57dfc"
import script from "./types.md?vue&type=script&lang=js"
export * from "./types.md?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__